import { v4 as uuidv4 } from 'uuid';
import preview from '@/assets/chart-preview/pie-basic.svg';
import { getLocaleStore } from '@/i18n';
import { getMaterialAssets } from '@/i18n/assets';
import { ChartType, LayerType } from '@/version-types';
import { defaultPresetColors } from '.';
import type { ChartPreset } from './type';

const chartType: ChartType = 'pie-basic';

const pieBasicPreset: ChartPreset = {
    id: `${chartType}-1`,
    type: chartType,
    preview,
    availableToChartTypes: [],
    create: () => ({
        layerType: LayerType.CHART,
        width: 1000,
        height: 1000,
        rotate: 0,
        opacity: 1,
        id: uuidv4(),
        left: 0,
        top: 0,
        lock: false,
        children: [],
        shine: false,
        hidden: false,
        title: '',
        fitWidth: 0,
        fitHeight: 0,
        extraInfo: {
            lockRatio: false,
        },
        data: {
            screenshotUrl: getMaterialAssets().chartLayer.screenshotUrl[chartType],
            type: chartType,
            chartData: [
                [null, `${getLocaleStore().$t((v) => v.chartLayer.data.series)}1`],
                [`${getLocaleStore().$t((v) => v.chartLayer.data.item)}1`, 10],
                [`${getLocaleStore().$t((v) => v.chartLayer.data.item)}2`, 4],
                [`${getLocaleStore().$t((v) => v.chartLayer.data.item)}3`, 2],
            ],
            colors: defaultPresetColors.slice(0, 3),
            grid: {
                show: false,
            },
            categoryAxisLabel: {
                show: true,
                textStyle: {
                    fontSize: 25,
                    color: '#999999',
                },
            },
            valueAxisLabel: {
                show: true,
                textStyle: {
                    fontSize: 25,
                    color: '#999999',
                },
            },
            legend: {
                show: true,
                position: 'bottom',
                textStyle: {
                    fontSize: 25,
                    color: '#999999',
                },
            },
            series: {
                label: {
                    show: false,
                    textStyle: {
                        fontSize: 25,
                        color: '#999999',
                    },
                },
            },
        },
    }),
};

export default pieBasicPreset;
